import { render, staticRenderFns } from "./DesignCheckbox.vue?vue&type=template&id=6e2b8be2&scoped=true&"
import script from "./DesignCheckbox.vue?vue&type=script&lang=js&"
export * from "./DesignCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./DesignCheckbox.vue?vue&type=style&index=0&id=6e2b8be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b8be2",
  null
  
)

export default component.exports